import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-account-cog',
  templateUrl: './icon-account-cog.component.html',
  styleUrl: './icon-account-cog.component.scss',
  standalone: false,
})
export class IconAccountCogComponent {
  @Input() tooltip?: string;
}
